// extracted by mini-css-extract-plugin
export default {"container":"Week_container__wPOxZ","spin":"Week_spin__Qysqz"};